import React from 'react'
import styles from './PrivateSpaceIcon.module.css'

const PrivateSpaceIcon = ({ size = 14 }) => (
  <img
    src="/assets/icons/lock-closed.svg"
    alt="Private space"
    title="Private space"
    width={size}
    height={size}
    className={styles.icon}
  />
)

export default PrivateSpaceIcon
